import { ENTRYPOINT, ENTRYPOINT_PUBLIC } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { getData, getHeaders, postData, putData, patchData } from '../../../http/request';

export const USER_ACTION_TYPES = {
	SIGN_IN_AUTHENTICATE_USER: 'SIGN_IN_AUTHENTICATE_USER',
	LOGOUT_USER: 'LOGOUT_USER',
    GET_SIGNED_USER_DATA: 'GET_SIGNED_USER_DATA',
	AUTHENTICATE_USER_FAIL: 'AUTHENTICATE_USER_FAIL',
	AUTHENTICATE_USER_FORBIDDEN: 'AUTHENTICATE_USER_FORBIDDEN',
	AUTHENTICATE_USER_SUCCESS: 'AUTHENTICATE_USER_SUCCESS'
};

const SIGNED_USER_DATA_URL = `${ENTRYPOINT}${API_ROUTES.SIGNED_USER_DATA}`;
const ADD_USER_URL = `${ENTRYPOINT}${API_ROUTES.ADD_USER}`;
const COMPANIES_URL = `${ENTRYPOINT}${API_ROUTES.COMPANIES}`;

export const getSignedUserData = async (dispatch) => {
    const response = await getData(SIGNED_USER_DATA_URL, getHeaders());
    dispatch({ type: USER_ACTION_TYPES.GET_SIGNED_USER_DATA, payload: response });
}

export const addUser = async (data) => await postData(ADD_USER_URL, data);

export const addUserPassword = async (token, data) => {
    const ADD_USER_PASSWORD_URL = `${ENTRYPOINT_PUBLIC}${API_ROUTES.ADD_USER_PASSWORD}/${token}`;
    return await putData(ADD_USER_PASSWORD_URL, data);
}

export const patchCompany = async (uuid, data) => {
    const URL = COMPANIES_URL + "/" + uuid;
    return await patchData(URL, data);
};
